// TableHeader.js

import React from 'react';
import { InputText } from 'primereact/inputtext';
import BootstrapDateRangePicker from './date/BootstrapDateRangePicker';
import Filter from './filter/Filter';
import ColumnsFilter from './filter/ColumnsFilter';

const TableHeader = ({ globalFilterValue, onGlobalFilterChange, dates, handleSelectedDate, supplyColumns
    , tableColumns, applyFiltersOnColumns }) => {

    return (
        <div className="flex justify-content-end" style={{ display: 'flex', justifyContent: 'end' }}>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" />
            </span>
            {/* <span className="p-input-icon-left">
                <i className="pi pi-calendar" />
                <BootstrapDateRangePicker
                    dates={dates}
                    selectedDate={handleSelectedDate}
                />
            </span> */}
            <span className="p-input-icon-left">
                <Filter
                    columnsList={supplyColumns}
                />
            </span>
            <span className="p-input-icon-left">
                <ColumnsFilter
                    columnsList={supplyColumns}
                    tableColumns={tableColumns}
                    index={7}
                    applyColumns={applyFiltersOnColumns}
                />
            </span>
        </div>
    );
};

export default TableHeader;
